// @flow

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { addTruthyParamsToUrl } from '@zapier/url-utils';

import Link from 'app/common/components/Link';

type HrefParams = { href: string };

const mapStateToProps = (state: Object, { href }: HrefParams): HrefParams => ({
  href: addTruthyParamsToUrl(href, RouterSelectors.getQueryParams(state)),
});

const LinkPreserveParamsContainer = connect(mapStateToProps)(Link);

LinkPreserveParamsContainer.propTypes = {
  href: PropTypes.string,
};

export default LinkPreserveParamsContainer;
